import netsSpeedDialFab from './nets-speed-dial-fab';

export default angular
  .module('app.speedDialFab', [])
  .component('netsSpeedDialFab', netsSpeedDialFab);
